import { type RouteObject } from 'react-router-dom';

import { firstAllowed, requirePermissions } from '@/app/requirePermissions';
import { PagePermissions } from '@/models/pagePermissions';

export const settingsRoute: RouteObject = {
  path: 'settings',
  children: [
    {
      // Not always 'general': an importer holding neither sandboxes:edit nor
      // languages:edit belongs on Import, which is the page they can use.
      index: true,
      loader: firstAllowed([
        { to: 'general', oneOf: PagePermissions.settingsGeneral },
        { to: 'import', oneOf: PagePermissions.settingsImport },
      ]),
    },
    {
      path: 'general',
      // The page also gates its two sections individually, so a viewer holding one of
      // the codes sees only what they may edit.
      loader: requirePermissions({ oneOf: PagePermissions.settingsGeneral }),
      lazy: () => import('./general'),
    },
    {
      path: 'import',
      // On the parent: one gate for the wizard and all of its steps.
      loader: requirePermissions({ oneOf: PagePermissions.settingsImport }),
      children: [
        {
          path: '',
          lazy: () => import('./import/index'),
        },
        {
          path: 'items',
          lazy: () => import('./import/item'),
        },
        {
          path: 'snapshot',
          lazy: () => import('./import/snapshot'),
        },
        {
          path: 'gifts',
          lazy: () => import('./import/gift'),
        },
        {
          path: 'season-passes',
          lazy: () => import('./import/seasonPass'),
        },
      ],
    },
  ],
};
